// social-embeds.js
// Loads social embeds (e.g. Twitter, Facebook, Instagram)

const endpoints = {
  instagram: function instagram(id) {
    return `https://api.instagram.com/oembed?url=https://instagr.am/p/${id}/&omitscript=true&maxwidth=600`;
  },
  twitter: function twitter(id) {
    return `https://api.twitter.com/1/statuses/oembed.json?url=https://twitter.com/twitter/status/${id}&omitscript=true&maxwidth=520&align=center`;
  },
  'facebook-post': function facebookPost(url) {
    return `https://apps.facebook.com/plugins/post/oembed.json/?url=${url}&omitscript=true`;
  },
  'facebook-video': function facebookVideo(url) {
    return `https://apps.facebook.com/plugins/video/oembed.json/?url=${url}&omitscript=true`;
  },
};

export default {
  /**
   * Makes an async request to a social embed's corresponding endpoint to fetch content
   * @param  {object} element HTML element corresponding to the embed wrapper.
   *   Element must have data-embed-type and data-embed-id/data-embed-url data attributes
   */
  get(element) {
    const embed = element;

    // Get embed
    const type = element.dataset.embedType;
    const xhr = new XMLHttpRequest();
    const corsproxy = 'https://dfxzeh0f5bej2.cloudfront.net/';
    let endpoint;

    if (element.dataset.embedId) {
      endpoint = endpoints[type](encodeURIComponent(element.dataset.embedId));
    } else if (element.dataset.embedUrl) {
      endpoint = endpoints[type](encodeURIComponent(element.dataset.embedUrl));
    }

    xhr.open('GET', corsproxy + endpoint, true);

    xhr.onreadystatechange = function load() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const responseObj = JSON.parse(xhr.responseText);

        if (responseObj.html) {
          embed.innerHTML = responseObj.html;

          if (type === 'twitter' && typeof window.twttr !== 'undefined') {
            window.twttr.widgets.load(embed);
          } else if (type === 'instagram' && typeof window.instgrm !== 'undefined') {
            window.instgrm.Embeds.process();
          }
        }
      }
    };

    xhr.send(null);
  },
};
